export default {
    install(app, options) {
        app.config.globalProperties.$document = {
            locationReload() { document.location.reload(); },
            locationAssign(url) { document.location = url; },
            window: window
        };
    }
}
